import { render } from "./ImageUploadControl.vue?vue&type=template&id=5629a084"
import script from "./ImageUploadControl.vue?vue&type=script&lang=js"
export * from "./ImageUploadControl.vue?vue&type=script&lang=js"

import "./ImageUploadControl.vue?vue&type=style&index=0&id=5629a084&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__